<template>
  <div class="page">
    <div class="container block-primary">
      <h1 class="header-title">Credits</h1>

      <ul>
        <li>Cart page: we use icon from by <a href="https://www.flaticon.com/packs/logistics-delivery">Freepik</a> from www.flaticon.com </li>
      </ul>

    </div>
  </div>
</template>

<script>

export default {
  name: 'credits'
}
</script>



// WEBPACK FOOTER //
// Credits.vue?587f09c4